export const MOBILE_BREAKPOINT = 960
export const TABLET_BREAKPOINT = 1024

const getDims = () => ({x: window.innerWidth, y: window.innerHeight})

let state = {
	dimensions: getDims()
};

export default {
	namespaced: true,
	state,
	getters: {
		dimensions: state => state.dimensions,
		width: state => state.dimensions.x,
		height: state => state.dimensions.y,
		isMobile: state => state.dimensions.x < MOBILE_BREAKPOINT,
		isTabletOrDown: state => state.dimensions.x < TABLET_BREAKPOINT,
		isDesktop: (_, getters) => !getters.isMobile,
		isLandscape: (state) => state.dimensions.x >= state.dimensions.y,
		isPortrait: (_, getters) => !getters.isPortrait
	},
	mutations: {
		DIMENSIONS: (state, dims) => { if(state.dims !== dims) state.dimensions = dims }
	},
	actions: {
		updateDims({commit}) {
			let dims = getDims()
			commit('DIMENSIONS', dims)
		},
		initListeners({dispatch}) {
			window.addEventListener('resize', () => dispatch('updateDims') )
			window.addEventListener('orientationchange', () => dispatch('updateDims') )
			screen.orientation.addEventListener('change', () => dispatch('updateDims') )
		}
	}
}
